import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LazyLoad from 'react-lazyload';
import { prismicImage } from 'src/common/utils/prismic-image';

import './PlaceholdImage.scss';

const Wrapper = ({ noLazyload, children }) => noLazyload ? children : <LazyLoad>{children}</LazyLoad>;

Wrapper.propTypes = {
  noLazyload: PropTypes.boolean,
  children: PropTypes.node,
};

const PlaceholdImage = props => {
  return (
    <div
      style={{ paddingTop: `${(props.image.dimensions.height / props.image.dimensions.width) * 100}%` }}
      className="PlaceholdImage__image--wrapper" >
      <Wrapper
        noLazyload={props.noLazyload}>
        <img
          className={cx('PlaceholdImage__image', {
            [ props.className ]: props.className
          })}
          src={prismicImage(props.image)}
          alt={props.image.alt}
          width={props.width}
        />
      </Wrapper>
    </div>
  );
};

PlaceholdImage.propTypes = {
  className: PropTypes.string,
  noLazyload: PropTypes.boolean,
  width: PropTypes.number,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    })
  }).isRequired,
};

export default PlaceholdImage;
